import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const ChatbotSettings = () => import('./ChatbotSettings.vue');
const ConciergeSettings = () => import('./ConciergeSettings.vue');
const QuickCommandsSettings = () => import('./QuickCommandsSettings.vue');
const AutomationsSettings = () => import('./AutomationsSettings.vue');
const PrioritySettings = () => import('./PrioritySettings.vue');
const VoiceSettings = () => import('./VoiceSettings.vue');
const PmsSettings = () => import('./PmsSettings.vue');

const ADMIN_ROLES = ['administrator'];

const LEGACY_EMAIL_WHATSAPP_SECTIONS = Object.freeze({
  'quick-commands': 'agent_ai_quick_commands_settings_index',
  automations: 'agent_ai_automations_settings_index',
});

const redirectLegacyEmailWhatsappSection = (to) => {
  const query = { ...(to.query || {}) };
  const routeName = LEGACY_EMAIL_WHATSAPP_SECTIONS[query.section];
  if (!routeName) return true;

  delete query.section;
  return {
    name: routeName,
    params: to.params,
    query,
    hash: to.hash,
  };
};

const buildAgentAISettingsRoute = ({
  path,
  routeName,
  component,
  headerTitle,
  icon,
  beforeEnter,
}) => ({
  path: frontendURL(`accounts/:accountId/settings/${path}`),
  roles: ADMIN_ROLES,
  component: SettingsContent,
  props: {
    headerTitle,
    icon,
    keepAlive: false,
  },
  children: [
    {
      path: '',
      name: routeName,
      component,
      roles: ADMIN_ROLES,
      ...(beforeEnter ? { beforeEnter } : {}),
    },
  ],
});

export default {
  routes: [
    buildAgentAISettingsRoute({
      path: 'agent-ai/chatbot',
      routeName: 'agent_ai_chatbot_settings_index',
      component: ChatbotSettings,
      headerTitle: 'SETTINGS_CENTER.CHATBOT',
      icon: 'bot',
    }),
    buildAgentAISettingsRoute({
      // Rotta storica: la Panoramica e i link salvati ci puntano ancora,
      // e rende la stessa pagina Automazioni.
      path: 'agent-ai/email-whatsapp',
      routeName: 'agent_ai_email_whatsapp_settings_index',
      component: AutomationsSettings,
      headerTitle: 'SETTINGS_CENTER.AUTOMATIONS',
      icon: 'calendar-clock',
      beforeEnter: redirectLegacyEmailWhatsappSection,
    }),
    buildAgentAISettingsRoute({
      path: 'agent-ai/quick-commands',
      routeName: 'agent_ai_quick_commands_settings_index',
      component: QuickCommandsSettings,
      headerTitle: 'SETTINGS_CENTER.QUICK_COMMANDS',
      icon: 'quick-commands',
    }),
    buildAgentAISettingsRoute({
      path: 'agent-ai/priority',
      routeName: 'agent_ai_priority_settings_index',
      component: PrioritySettings,
      headerTitle: 'SETTINGS_CENTER.PRIORITY',
      icon: 'arrow-sort',
    }),
    buildAgentAISettingsRoute({
      path: 'agent-ai/automations',
      routeName: 'agent_ai_automations_settings_index',
      component: AutomationsSettings,
      headerTitle: 'SETTINGS_CENTER.AUTOMATIONS',
      icon: 'calendar-clock',
    }),
    buildAgentAISettingsRoute({
      path: 'agent-ai/voice',
      routeName: 'agent_ai_voice_settings_index',
      component: VoiceSettings,
      headerTitle: 'SETTINGS_CENTER.VOICE',
      icon: 'call',
    }),
    buildAgentAISettingsRoute({
      // Il campanello: lo stesso segno del badge della casella Concierge.
      path: 'agent-ai/concierge',
      routeName: 'agent_ai_concierge_settings_index',
      component: ConciergeSettings,
      headerTitle: 'SETTINGS_CENTER.CONCIERGE',
      icon: 'alert',
    }),
    buildAgentAISettingsRoute({
      path: 'integrations/pms',
      routeName: 'agent_ai_pms_settings_index',
      component: PmsSettings,
      headerTitle: 'SETTINGS_CENTER.PMS',
      icon: 'link',
    }),
  ],
};
